import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateNexusStats = (state: StatsSnapshot) => {
  const nexus = state.generators.nexus;

  const generatedAcademies = nexus.owned * nexus.baseGeneration;

  stats.nexus = {
    buildingsGeneration: generatedAcademies,
  };
};
